import { AlertNotifications } from 'components/AlertNotification';
import { getHasRentalProduct } from 'components/Cart/selector';
import connect from 'components/Shared/connect';
import { AlertNotification, DisplayType } from 'models/AlertNotification';
import { CheckoutFormData } from 'models/CheckoutFormData';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { rm } from 'utils';
import { checkoutForm } from 'views/CheckoutPage/selector';
import AutoForm from './autoForm';
import ManualForm from './manualForm';

interface OwnProps {
  reset: (quickStart: boolean) => void;
}
interface MergedProps extends OwnProps {
  hasRotDeduction: boolean;
  quickStart: boolean;
}

const _ContactInfoCompany = ({ reset, hasRotDeduction, quickStart }: MergedProps) => {
  const [useQuickStart, setQuickStart] = useState(quickStart);
  const toggleQuickStart = () => {
    const newQuickStartValue = !useQuickStart;
    setQuickStart(newQuickStartValue);
    reset(newQuickStartValue);
  };
  const resetForm = () => {
    reset(useQuickStart);
  };

  const hasRentalProducts = useSelector(getHasRentalProduct);

  const alerts: AlertNotification[] = [];

  if (hasRotDeduction) {
    alerts.push({
      message: rm('checkout_company_rot_error'),
      displayType: DisplayType.Information
    });
  }

  if (hasRentalProducts) {
    alerts.push({
      message: rm('checkout_company_rentalProduct_error'),
      displayType: DisplayType.Information
    });
  }

  return (
    <div>
      <AlertNotifications alerts={alerts} isDisabled={false} />

      {useQuickStart ? (
        <AutoForm resetForm={resetForm} toggleQuickStart={toggleQuickStart} />
      ) : (
        <ManualForm toggleQuickStart={toggleQuickStart} />
      )}
    </div>
  );
};

type FormProps = Pick<CheckoutFormData, 'address' | 'cache' | 'quickStart'>;
interface StateProps {
  form: FormProps;
}
export const ContactInfoCompany = connect<MergedProps, OwnProps, StateProps>(
  state => ({
    form: checkoutForm(state, 'address', 'cache', 'quickStart') as FormProps,
    hasRotDeduction: state.cart.hasRotDeduction
  }),
  undefined,
  ({ form, ...state }, dispatch, props) => ({
    ...state,
    ...dispatch,
    ...props,
    quickStart: form.quickStart
  })
)(_ContactInfoCompany);
